import type { ReactNode } from "react";
import { LoadingState } from "../../ui/loading-state";
import { workspaceText } from "../i18n";
import type { WorkspaceLocale } from "../i18n";

export interface WorkspaceLoadingFallbackProps {
  readonly locale?: WorkspaceLocale | undefined;
}

export function WorkspaceLoadingFallback({ locale = "en" }: WorkspaceLoadingFallbackProps): ReactNode {
  return <LoadingState label={workspaceText(locale, "workspaceLoading")} />;
}
